import axios from "axios";
import { INTERFACE, NONE_INDENTIFIER } from "../constants.mjs";
import { getUserMeUrl } from "../utils/getAppUserIdUrl.mjs";
import { getPhase } from "../utils/schemeUtils.mjs";
const axiosInstance = axios.create({ withCredentials: true, timeout: 5e3 });
function getAppUserId() {
  const apiUrl = getUserMeUrl();
  if (!apiUrl) {
    return new Promise(() => {
      console.error(
        "[appUserId] : kakao.com 및 kakaopay.com 도메인에서만 호출 가능합니다."
      );
      throw new Error(
        "[appUserId] : kakao.com 및 kakaopay.com 도메인에서만 호출 가능합니다."
      );
    });
  }
  const url = apiUrl[getPhase()];
  return axiosInstance.get(url).then((response) => {
    return new Promise((resolve, reject) => {
      try {
        resolve({
          command: INTERFACE.APP_USER_ID,
          success: true,
          result: {
            app_user_id: response.data.app_user_id || response.data.appUserId
          },
          extras: {
            identifier: NONE_INDENTIFIER
          }
        });
      } catch (e) {
        reject(e);
      }
    });
  }).catch((e) => {
    console.log(e);
    throw e;
  });
}
export {
  getAppUserId
};
